import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const ThinLoader = styled.div<IThinLoaderProps>`
  width: 100%;
  height: 4px;
  background-color: white;
  overflow: hidden;
  position: relative;
  will-change: transform;

  ${isNot('visible')`
    opacity: 0;
  `};

  ${is('positionTopSticky')`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
  `};

  &:before {
    ${isNot('visible')`
      display: none;
    `};

    display: block;
    content: '';
    height: 4px;
    animation: loading 2s linear infinite;
    ${is('animationTime')`
      animation: loading ${({ animationTime }: IThinLoaderProps) =>
        animationTime}s linear infinite;
    `};
    background-color: ${({ theme }: ITheme) => theme.colors.palette.emerald};
    ${is('colorInside')`
      background-color: ${({ colorInside }: IThinLoaderProps) => colorInside};
    `};

    width: 20%;
    ${is('widthInside')`
      width: ${({ widthInside }: IThinLoaderProps) => widthInside}%;
    `}
  }
  @keyframes loading {
    from {
      transform: translateX(-100%);
    }
    80% {
      transform: translateX(50vw);
    }
    to {
      transform: translateX(100vw);
    }
  }
`

export default ThinLoader

export interface IThinLoaderProps {
  visible?: boolean

  colorInside?: string
  widthInside?: number
  animationTime?: number

  positionTopSticky?: boolean
}
